import React from 'react'
import { Alert } from 'react-bootstrap'
import { StatusMarker } from '../StatusMarker'

export const MissingAKPMessage = () => {
  return (
    <div>
      <div className="canvas-flex-wrapper">
        <div className="canvas-form-container">
          <h2>Brightspace Integration</h2>
          <p>
            <Alert variant="warning">
              An App Key Pair <strong>has not</strong> been associated with this
              course.
            </Alert>
          </p>
          <p>
            In order to integrate your MyEducator course with Brightspace, your
            organization&apos;s LMS administrator must first register MyEducator
            by creating an App Key Pair. Once registered, you&apos;ll be able to
            complete the integration.
          </p>
          <p>
            Please contact our support team at &nbsp;
            <a href="mailto:support@myeducator.com?subject=Brightspace Integration">
              support@myeducator.com
            </a>
            &nbsp; for help getting started. We&apos;ll work closely with your
            organization&apos;s LMS administrator to get everything figured out!
          </p>
        </div>
        <div className="canvas-statusmarker-container">
          <StatusMarker iconType="icon_notification" />
        </div>
      </div>
    </div>
  )
}

